// CalendarMonth > Day > Day
import React from 'react'
import { CalendarMonthDayProps, calendarMonthDayDefaultProps } from './IDay'
import FlexBox from '../../FlexBox'
import Text from '../../Text'
import classNames from 'classnames'
import { isToday, isSameMonth } from '../../utils/Dates'
import styles from './Day.module.css'

export default class CalendarMonthDay extends React.PureComponent<CalendarMonthDayProps, {}> {
	static readonly defaultProps = calendarMonthDayDefaultProps

	private _handleDateSelect = (event: React.MouseEvent<HTMLHeadingElement | HTMLParagraphElement>) => {
		event.stopPropagation()
		const { onSelect, date } = this.props

		onSelect(date)
	}

	render() {
		const { date, isSelected, displayDate } = this.props
		const applyToday = isToday(date)

		return (
			<FlexBox container justify="center">
				<Text
					role="button"
					className={classNames(styles.text, {
						[styles['other-month']]: !isSameMonth(date, displayDate),
						[styles.selected]: isSelected,
						[styles.today]: applyToday
					})}
					onClick={this._handleDateSelect}
				>
					{date.getDate()}
				</Text>
			</FlexBox>
		)
	}
}
